import * as React from "react";
import { SVGProps, Ref, forwardRef } from "react";
const SvgComponent = (props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width="1em"
        height="1em"
        fill="none"
        viewBox="0 0 24 24"
        ref={ref}
        {...props}
    >
        <path
            fill="currentColor"
            fillRule="evenodd"
            d="M2.85 3.7a.7.7 0 0 1 .7-.7h5.633a.7.7 0 0 1 .7.7v5.533a.7.7 0 0 1-.7.7H3.55a.7.7 0 0 1-.7-.7V3.7Zm1.4.7v4.133h4.233V4.4H4.25ZM14.117 14.767a.7.7 0 0 1 .7-.7h5.633a.7.7 0 0 1 .7.7V20.3a.7.7 0 0 1-.7.7h-5.633a.7.7 0 0 1-.7-.7v-5.533Zm1.4.7V19.6h4.233v-4.133h-4.233Z"
            clipRule="evenodd"
        />
        <path
            fill="currentColor"
            fillRule="evenodd"
            d="M8.937 6.807H8.5v-1.4h.437a.7.7 0 1 1 0 1.4Zm1.926-.7a.7.7 0 0 1 .7-.7h.812a.7.7 0 1 1 0 1.4h-.813a.7.7 0 0 1-.7-.7Zm3.062 0a.7.7 0 0 1 .7-.7h.75a.7.7 0 1 1 0 1.4h-.75a.7.7 0 0 1-.7-.7Zm3 0a.7.7 0 0 1 .7-.7H18a.7.7 0 0 1 .7.7v.736a.7.7 0 1 1-1.4 0v-.116a.7.7 0 0 1-.375-.62ZM5.3 8.992v-.43h1.4v.43a.7.7 0 1 1-1.4 0ZM18 10.563a.7.7 0 0 1 .7.7v1.167a.7.7 0 1 1-1.4 0v-1.167a.7.7 0 0 1 .7-.7ZM6 10.87a.7.7 0 0 1 .7.7v1.167a.7.7 0 1 1-1.4 0V11.57a.7.7 0 0 1 .7-.7Zm12 3.438a.7.7 0 0 1 .7.7v.43h-1.4v-.43a.7.7 0 0 1 .7-.7ZM6 16.457a.7.7 0 0 1 .7.7v.116a.7.7 0 0 1-.325 1.32H6a.7.7 0 0 1-.7-.7v-.736a.7.7 0 0 1 .7-.7Zm1.925 1.436a.7.7 0 0 1 .7-.7h.75a.7.7 0 1 1 0 1.4h-.75a.7.7 0 0 1-.7-.7Zm3 0a.7.7 0 0 1 .7-.7h.813a.7.7 0 1 1 0 1.4h-.813a.7.7 0 0 1-.7-.7Zm3.438 0a.7.7 0 0 1 .7-.7h.437v1.4h-.438a.7.7 0 0 1-.7-.7Z"
            clipRule="evenodd"
        />
    </svg>
);
const ForwardRef = forwardRef(SvgComponent);
export default ForwardRef;
